import axios from 'axios';

export const getSecuritiesComponentsById = (securityId) => axios.get(
    `${global?.AppConfig?.SERVICES_URL_SUFFIX}/v1.0/securities/${securityId}/components?language=de`,
);

export const getSecuritiesById = (securityId) => axios.get(
    `${global?.AppConfig?.SERVICES_URL_SUFFIX}/v1.1/securities/${securityId}?language=de`,
);

export const getSecuritiesFondsBreakDown = (securityId) => axios.get(
    `${global?.AppConfig?.SERVICES_URL_SUFFIX}/v1.0/securities/${securityId}/fund-breakdown?language=de`,
    { category: 'focus' },
);

export const postFocuses = (body) => axios.post(
    `${global?.AppConfig?.SERVICES_URL_SUFFIX}/v1.0/focuses/search?language=de`,
    body,
);
